export const DEFAULT_TOOLTIP_CLASSNAME =
  "absolute p-1 transition-all duration-300 ease-in-out z-5 rounded-20";

export const DEFAULT_CONTENT_CLASSNAME =
  "p-2 bg-white-base border border-black-base/20 shadow-light rounded-20";

export const POSITION_CLASSNAME = {
  top: "bottom-7 left-1/2 -translate-x-1/2",
  bottom: "top-7 left-1/2 -translate-x-1/2",
  left: "top-1/2 left-0 -translate-y-1/2 -translate-x-full",
  right: "top-1/2 right-0 -translate-y-1/2 translate-x-full",
};
